var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-secondary-text-field"},[_c('v-text-field',_vm._g(_vm._b({attrs:{"dense":"","single-line":"","hide-details":"","outlined":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }